<template>
  <button @click="setComponent">{{ $t("buttons.return") }}</button>
</template>

<script>
export default {
  name: "HelpBackComponent",

  methods: {
    setComponent() {
      this.$emit("changeComponent", "Options");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: #fafafa;
  border-radius: 8px;
  padding: 6px 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    background: #eeeeee;
  }
}
</style>
